<template>
  <div id="splash-wrapper">
    <div id="splash-content">
      <div>OrbitCM App</div>
      <v-img :src="require('@/assets/globe-computer.gif')"></v-img>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#splash-wrapper {
  display: flex;
  height: 100vh;
  width: 100vw;
  position: absolute;
  align-items: center;
  text-align: center;
}

#splash-content {
  width: 100%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (min-width: 1200px) {
  #splash-content {
    max-width: 400px;
  }
}
</style>
